import React from "react";
import { Link } from "react-router-dom";

import EventNavigation from "../EventsPage/EventNavigation/EventNavigation";
import Footer from "../EventsPage/Footer/Footer";
import "./account_deletion.css";

const AccountDeletionPage = () => {
  return (
    <>
      <EventNavigation />

      <main id="account_deletion_page">
        <section id="account_deletion_hero">
          <p id="account_deletion_eyebrow">PropTech Club</p>
          <h1 id="account_deletion_title">Delete Your Account</h1>
          <p id="account_deletion_intro">
            You can delete your PropTech Club account and its associated data at
            any time, using either of the two methods below.
          </p>
        </section>

        <section id="account_deletion_content">
          <article className="account_deletion_card">
            <h2>Option 1: Delete your account in the app</h2>
            <ol>
              <li>
                Open the <strong>PropTech Club</strong> app and sign in.
              </li>
              <li>
                Go to <strong>Profile → Settings</strong>.
              </li>
              <li>
                Tap <strong>Delete Account</strong> and confirm.
              </li>
            </ol>
            <p>
              Your account and associated data are deleted once you confirm.
            </p>
          </article>

          <article className="account_deletion_card">
            <h2>Option 2: Request deletion by email</h2>
            <p>
              If you no longer have the app installed, you can request deletion
              without reinstalling it:
            </p>
            <ol>
              <li>
                Email us at{" "}
                <a href="mailto:info@proptechclub.org">info@proptechclub.org</a>{" "}
                from the email address registered to your account.
              </li>
              <li>
                Use the subject line{" "}
                <strong>“Delete my PropTech Club account”</strong>.
              </li>
            </ol>
            <p>
              We will verify your request and delete your account within{" "}
              <strong>7 days</strong>, and confirm by reply once it is done.
            </p>
          </article>

          <article className="account_deletion_card">
            <h2>What is deleted</h2>
            <ul>
              <li>
                Your account profile (name, email address, and phone number if
                provided)
              </li>
              <li>Your in-app activity and preferences</li>
            </ul>
            <p>
              Some records may be retained where required by law (for example,
              transaction or compliance records), and are removed once that
              retention period ends. Data that has already been anonymized
              cannot be linked back to you.
            </p>
          </article>

          <article className="account_deletion_card account_deletion_contact">
            <h2>Questions</h2>
            <p>
              For any questions contact us at{" "}
              <a href="mailto:info@proptechclub.org">info@proptechclub.org</a>
            </p>
            <Link id="account_deletion_back_link" to="/">
              Back to PropTech Club
            </Link>
          </article>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default AccountDeletionPage;
